export default [
    {
        path: 'fabricante',
        component: () => import(
            /* webpackChunkName: 'cadastro-fabricante' */
            '@/views/cadastro/fabricante/Index'
        ),
        redirect: 'fabricante/index',
        children: [
            {
                name: 'cadastro-fabricante-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-fabricante' */
                    '@/views/cadastro/fabricante/List.vue'
                ),
            },
            {
                name: 'cadastro-fabricante-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-fabricante' */
                    '@/views/cadastro/fabricante/Form.vue'
                ),
            },
            {
                name: 'cadastro-fabricante-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-fabricante' */
                    '@/views/cadastro/fabricante/Form.vue'
                ),
            },
        ],
    },
]